import angular from 'angular'
import channelTogglesComponent from './channelToggles.component'

export default angular
  .module('ellipsis.channelToggles', [])
  .component('channelToggles', channelTogglesComponent)
